<template>
  <el-table
    v-if="showTable"
    v-loading="tableLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :ref="tableRef"
    :key="tableKey"
    :data="tableData"
    :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
    :cell-style="{border:'1px solid #dcdfe6'}"
    stripe
    :max-height="isPc?(screenHeight-50>600?(screenHeight-50):600):90000"
    style="width:100%;border: 1px solid #dcdfe6;"
    row-key="id"
    :tree-props="{ children: 'childrenList' }"
    :border="!isPc"
  >
    <el-table-column label="序号" :width="isPc?'120':'48'" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.id | filterId(type) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="title"
      :width="isPc?'230':''" align="center">
      <template slot-scope="scope">
        <div v-if="!!scope.row.sourceList"
          @click="clickRecommend(scope.row)"
          :style="`color: ${textColor}; text-decoration: underline;cursor:pointer;`"
        >
          {{ scope.row.name }}
        </div>
        <div v-else>{{ scope.row.name }}</div>
      </template>
    </el-table-column>
    <el-table-column label="样本实际采集量" align="center">
      <el-table-column prop="totalAmount" :label="'总样本量\n(X+Y)'" :width="isPc?'':'55'" align="center">
      </el-table-column>
      <el-table-column label="主问卷采集量" align="center" :width="isPc?'':'55'">
        <el-table-column prop="amount" :label="'小计(X)'" :width="isPc?'':'55'" align="center">
        </el-table-column>
        <el-table-column prop="publicAmount" label="公众版" :width="isPc?'':'55'" align="center">
        </el-table-column>
        <el-table-column prop="employmentAmount" label="从业版" :width="isPc?'':'55'" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column prop="specialAmount" :label="'专题问卷采集量\n(Y)'" :width="isPc?'':'55'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column label="操作" :width="isPc?'':'40'" align="center" prop="">
      <template slot-scope="scope" v-if="scope.row.name!='/'&&scope.row.name!='合计'">
        <el-button v-if="scope.row.totalAmount>50" @click="createPlacard(scope.row, 1)" type="primary" size="mini">{{isPc?'生成喜报':'喜报'}}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ComTable',
  props: {
    type: {
      type: Number,
      default: 1
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    },
    showTable: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: ''
    },
    tableRef: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    screenHeight: {
      type: Number,
      default: document.body.screenHeight
    },
  },
  data() {
    return {
      tableKey: 0, // 强制刷新标识
    }
  },
  created() {
    // console.log('DialogTable created', this.title);
  },
  updated() {
    // console.log('DialogTable updated', this.title);
    // 没有用
    // this.$nextTick(() => {
    //   this.$refs[this.title].doLayout();
    // })
  },
  filters: {
    filterId: function (value, type) {
      if(!value) {
        return ' '
      }
      let count = 0;
      for (let i = 0; i < value.length; i++) {
        if (value.charAt(i) === '-') {
          count++;
        }
      }
      if(count===0) {
        return Number(value)?value:' '
      }else if ( type === 2 && count===1 ) {
        let ary = value.split('-')
        return `(${ary[count]})`
      }else if ( type === 2 && count===2 ) {
        let ary = value.split('-')
        return `[${ary[count]}]`
      }else {
        return ' '
      }
    },
  },
  watch: {
    // 监听 tableRef 变化，重置表格
    tableRef(newVal, oldVal) {
      // 只有当 tableRef 真正变化且组件已挂载时才重建
      if (newVal !== oldVal && this.$el) {
        this.$nextTick(() => {
          this.tableKey += 1;
        });
      }
    }
  },
  methods: {
    clickRecommend(row) {
      this.$emit('clickRecommend', row);
    },
    createPlacard(row, type) {
      this.$emit('createPlacard', row, type);
    },
  }
};
</script>

<style scoped>

@media screen and (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/table/ComTable.vue